import { CheckCircleIcon } from '@assets/icons/CheckCircleIcon';
import { GenericNotification, NotificationTheme } from './GenericNotification';

export const SuccessNotification = ({
  title,
  description,
  theme = 'dark',
}: {
  title: string;
  description: string;
  theme?: NotificationTheme;
}) => {
  return (
    <GenericNotification
      title={title}
      description={description}
      icon={<CheckCircleIcon className="mr-4" />}
      testId="notifications-success"
      type="success"
      theme={theme}
    />
  );
};
